// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'warn';

export const Component = () => (
  <path d='M12.5 4.468 3.085 21.561h18.83L12.5 4.468Zm11 18.032h-22l11-20 11 20ZM13.759 9.39v6.175a2.99 2.99 0 0 1-1.166.223c-.466 0-.886-.09-1.212-.223V9.39c.42-.313.792-.447 1.212-.447.42 0 .839.134 1.166.447Zm.466 9.396c0 .403-.14.76-.466 1.074a1.728 1.728 0 0 1-1.212.492c-.42 0-.792-.179-1.119-.492-.326-.313-.512-.671-.512-1.074 0-.447.186-.85.512-1.163a1.55 1.55 0 0 1 1.119-.447c.466 0 .886.134 1.212.447.326.313.466.716.466 1.163Z' />
);

export const viewBox = '0 0 25 25';
